import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = {
    url: String,
    active: Boolean,
    id: Number,
  };

  connect() {
    this.dragging = false;
    this.editing = false;

    if (window.sectionCardPendingEdit && this.idValue === Number(window.sectionCardPendingEdit)) {
      delete window.sectionCardPendingEdit;
      requestAnimationFrame(() => {
        const placeholder = this.element.querySelector("[data-inline-edit-target='placeholder']");
        if (placeholder) {
          placeholder.dispatchEvent(new MouseEvent("click", { bubbles: true }));
        }
      });
    }
  }

  open(event) {
    if (!this.hasUrlValue || this.dragging || this.editingActive() || this.shouldIgnore(event) || this.notPrimary(event)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.visit();
  }

  openFromButton(event) {
    if (!this.hasUrlValue) return;

    event.preventDefault();
    event.stopPropagation();
    this.visit();
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  startDrag(event) {
    if (event.detail?.item !== this.element) return;
    this.dragging = true;
  }

  endDrag(event) {
    if (event.detail?.item !== this.element) return;
    this.dragging = false;
  }

  shouldIgnore(event) {
    if (event.defaultPrevented) return true;
    const ignoreNode = event.target.closest("[data-section-card-ignore]") || event.target.closest("[data-section-card-ignore='true']");
    return Boolean(ignoreNode);
  }

  visit() {
    Turbo.visit(this.urlValue, { frame: "sections-modules-frame" });
  }

  notPrimary(event) {
    return typeof event.button === "number" && event.button !== 0;
  }

  enterEdit() {
    this.editing = true;
  }

  exitEdit() {
    this.editing = false;
  }

  editingActive() {
    if (this.editing) return true;
    return Boolean(this.element.querySelector(".inline-edit__input:not(.hidden)"));
  }

  maybeActivateAndEdit(event) {
    if (this.activeValue) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    window.sectionCardPendingEdit = this.idValue;
    this.visit();
  }
}
